import { MenuItem } from '@types'
import {
  StartUp,
  NLP,
  TimeSeries,
  Correlation,
  GeoAnalysis,
  StartUpComparison,
} from '@pages'
import { ReactComponent as StartUpIcon } from '../assets/img/Comparison.svg'
import { ReactComponent as ComparisonIcon } from '../assets/img/Comparison.svg'
import { ReactComponent as CorrelationIcon } from '../assets/img/Correlation.svg'
import { ReactComponent as TSIcon } from '../assets/img/Time Series.svg'
import { ReactComponent as NLPIcon } from '../assets/img/NLP.svg'
import { ReactComponent as GeoIcon } from '../assets/img/Geographical.svg'
import { StartUpComparisonIcon } from '../assets/icons/startUpComparison'
//MENU
export const MenuItems: MenuItem[] = [
  {
    path: '/correlation',
    label: 'Correlation',
    element: <Correlation />,
    userRoles: [],
    icon: <CorrelationIcon style={{ width: '22px', height: '22px' }} />,
  },
  {
    path: '/start-up',
    label: 'Dettagli Start-Up',
    element: <StartUp />,
    userRoles: [],
    icon: <StartUpIcon style={{ width: '22px', height: '22px' }} />,
  },
  {
    path: '/start-up-comparison',
    label: 'Confronto Start-Up',
    element: <StartUpComparison />,
    userRoles: [],
    icon: <StartUpComparisonIcon style={{ width: '22px', height: '22px' }} />,
  },
  {
    path: '/time-series',
    label: 'Time series',
    element: <TimeSeries />,
    userRoles: [],
    icon: <TSIcon style={{ width: '22px', height: '22px' }} />,
  },
  {
    path: '/NLP',
    label: 'NLP Analysis',
    element: <NLP />,
    userRoles: [],
    icon: <NLPIcon style={{ width: '22px', height: '22px' }} />,
  },
  {
    path: '/geo',
    label: 'Geographical Analysis',
    element: <GeoAnalysis />,
    userRoles: [],
    icon: <GeoIcon style={{ width: '22px', height: '22px' }} />,
  },
]
